import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Components as Switch } from './switch.style';
import ErrorMessage from '../ErrorMessage';
import Hint from '../Hint';
export const StandardSwitch = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className = 'standard-switch',
      id,
      checked = false,
      disabled = false,
      required = false,
      label,
      error,
      hint,
      value,
      fit = 'medium',
      orientation = 'horizontal',
      showOptional,
      width
    } = props,
    restProps = __rest(props, ["className", "id", "checked", "disabled", "required", "label", "error", "hint", "value", "fit", "orientation", "showOptional", "width"]);
  return _jsxs(Switch.Wrapper, _extends({
    disabled: disabled,
    width: width,
    className: className
  }, {
    children: [_jsx(React.Fragment, {
      children: _jsxs(Switch.Label, _extends({
        htmlFor: id,
        fit: fit,
        orientation: orientation,
        checked: checked,
        disabled: disabled,
        className: disabled ? 'disabled' : '',
        tabIndex: 0
      }, {
        children: [_jsx(Switch.Input, _extends({
          id: id,
          checked: checked,
          value: value,
          disabled: disabled,
          ref: ref
        }, restProps)), label, showOptional && !required && _jsx("span", _extends({
          className: "optional"
        }, {
          children: " (optional)"
        })), !showOptional && required && _jsx("span", {
          className: "required"
        })]
      }))
    }), error && _jsx(ErrorMessage, _extends({
      fit: fit
    }, restProps)), hint && _jsx(Hint, {
      hint: hint,
      fit: fit
    })]
  }));
});
export default StandardSwitch;